import { useState } from "react";
import { FaUserPlus, FaPlug, FaBroadcastTower, FaCheckCircle, FaShoppingCart, FaTruckLoading, FaMapMarkedAlt, FaClock } from "react-icons/fa";

export default function Timeline() {
  const [activeTab, setActiveTab] = useState("business");

  const customerEvents = [
    { id: 1, title: "Free Sign-up with Tuber", icon: <FaUserPlus size={24} />, disc: "Join Tuber at no cost and instantly access our commercial delivery network." },
    { id: 2, title: "Plug in with Tuber’s Desktop API", icon: <FaPlug size={24} />, disc: "Seamlessly integrate Tuber’s ordering system into your business operations for automated, efficient logistics." },
    { id: 3, title: "Go Live!", icon: <FaBroadcastTower size={24} />, disc: "Start placing and managing orders effortlessly, reducing downtime and improving project efficiency." },
    { id: 4, title: "Deliveries Confirmed, Assigned, and Delivered!", icon: <FaCheckCircle size={24} />, disc: "Our system ensures every order is swiftly processed, assigned to a driver, and delivered straight to your job site." },
  ];

  const businessEvents = [
    { id: 1, title: "Place Order", icon: <FaShoppingCart size={24} />, disc: "Easily request materials from your nearest trade store via the Tuber app or website. Enter your location, select your items, and confirm your order in seconds." },
    { id: 2, title: "We Assign a Driver for Pick Up", icon: <FaTruckLoading size={24} />, disc: "A nearby registered Tuber driver will be dispatched to the selected store to pick up your order, ensuring the fastest possible delivery." },
    { id: 3, title: "Real-Time Tracking", icon: <FaMapMarkedAlt size={24} />, disc: "Track your order in real time with live GPS updates, so you know exactly when your materials will arrive." },
    { id: 4, title: "Delivered in 2 Hours", icon: <FaClock size={24} />, disc: "Your items arrive on-site in two hours or less, keeping your workflow uninterrupted and your team focused." },
  ];

  const timelineEvents = activeTab === "business" ? customerEvents : businessEvents;

  return (
    <div className="px-5 py-12 max-w-4xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-headings">What We Do</h1>

      {/* Tabs */}
      <div className="max-w-[450px] mx-auto mb-20 text-center bg-primary bg-opacity-10 rounded-full p-[6px] flex">
        <button
          className={`max-w-[250px] w-full py-[10px] px-3 md:px-4 text-base tracking-wider font-semibold rounded-full transition-colors ${activeTab === "business" ? "bg-primary text-white" : "text-black/70"
            }`}
          onClick={() => setActiveTab("business")}
        >
          For Your Businesss
        </button>

        <button
          className={`max-w-[250px] w-full py-[10px] px-3 md:px-4 text-base tracking-wider font-semibold rounded-full transition-colors ${activeTab === "customers" ? "bg-primary text-white" : "text-black/70"
            }`}
          onClick={() => setActiveTab("customers")}
        >
          For Your Customers
        </button>
      </div>

      {/* Timeline */}
      <div className="relative">
        {/* Vertical timeline bar */}
        <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary opacity-20"></div>

        {/* Timeline events */}
        {timelineEvents.map((event, index) => (
          <div key={event.id} className="flex pb-10 md:pb-16 timeline pl-6 md:pl-0 flex-col md:flex-row">
            <div className="md:w-5/12 text-left">
              <span className="text-sm font-bold text-btn_hover uppercase">{`Step 0${event.id}`}</span>

              <h3 className="text-lg md:text-xl font-semibold text-headings">{event.title}</h3>
            </div>

            {/* Center dot & bar */}
            <div className="w-[17%] flex justify-start md:justify-center absolute md:relative -left-3 md:left-auto">
              <div className="w-6 h-6 rounded-full bg-primary z-40"></div>
            </div>

            <div className="md:w-5/12 flex gap-2 md:gap-3">
              <div className="h-10 flex items-center justify-center text-primary">
                {event.icon}
              </div>

              <p className="flex-1 text-sm md:text-lg text-light_black pt-1">
                {event.disc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
